module.exports = __webpack_public_path__ + "static/media/use_graph01_eng.a3963cf1.jpg";